import { render, staticRenderFns } from "./priceConfig.vue?vue&type=template&id=1e9cbbe0&scoped=true"
import script from "./priceConfig.vue?vue&type=script&lang=js"
export * from "./priceConfig.vue?vue&type=script&lang=js"
import style0 from "./priceConfig.vue?vue&type=style&index=0&id=1e9cbbe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9cbbe0",
  null
  
)

export default component.exports